const ActivationStatusAction = {

    GET_ACTIVATION_STATUS: "GET_ACTIVATION_STATUS",

    GET_ACTIVATION_STATUS_SUCCESS:
        "GET_ACTIVATION_STATUS_SUCCESS",

    GET_ACTIVATION_STATUS_FAILURE:
        "GET_ACTIVATION_STATUS_FAILURE",


    getActivationStatus: (payload) => ({
        type: ActivationStatusAction.GET_ACTIVATION_STATUS,
        payload
    }),


    getActivationStatusSuccess: (payload) => ({
        type: ActivationStatusAction.GET_ACTIVATION_STATUS_SUCCESS,
        payload
    }),


    getActivationStatusFailure: (error) => ({
        type: ActivationStatusAction.GET_ACTIVATION_STATUS_FAILURE,
        payload: error
    })

};

export default ActivationStatusAction;